import ScanHistoryTable from "./scanHistoryTable.container"

export default ScanHistoryTable
